import { Question } from 'inquirer'

export interface ExtendedQuestion extends Question {
  choices?: string[]
  transformer?: (text: string, answers: Record<string, unknown>, flags: Record<string, unknown>) => string
}

export interface ExtendedQuestionMap {
  [key: string]: ExtendedQuestion
}
